var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "base-card-tabbed", attrs: { row: "", wrap: "" } },
    [
      _c(
        "base-card",
        _vm._g(
          _vm._b(
            {
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.$scopedSlots, function(index, name) {
                    return {
                      key: name,
                      fn: function(data) {
                        return [_vm._t(name, null, null, data)]
                      }
                    }
                  }),
                  {
                    key: "table",
                    fn: function() {
                      return [
                        _vm._t("shared-card-contents"),
                        _vm._v(" "),
                        _vm.tabs.length === 0
                          ? _c(
                              "div",
                              { key: "no-tabs" },
                              [
                                _vm._t("no-tabs", [
                                  _c("p", { staticClass: "ma-0 px-3 py-2" }, [
                                    _vm._v("No content provided")
                                  ])
                                ])
                              ],
                              2
                            )
                          : _c("base-tabs", {
                              key: "has-tabs",
                              attrs: {
                                tabs: _vm.tabs,
                                "has-titles": _vm.hasTitles,
                                "show-arrows": _vm.showArrows
                              },
                              on: {
                                input: function($event) {
                                  return _vm.$emit("tab-change")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function(ref) {
                                      var tab = ref.tab
                                      return [
                                        _vm._t("tab-title", null, { tab: tab })
                                      ]
                                    }
                                  },
                                  {
                                    key: "content",
                                    fn: function(ref) {
                                      var tab = ref.tab
                                      return [
                                        _vm._t("tab-content", null, {
                                          tab: tab
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "action",
                                    fn: function() {
                                      return [_vm._t("tab-action")]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.activeTab,
                                callback: function($$v) {
                                  _vm.activeTab = $$v
                                },
                                expression: "activeTab"
                              }
                            })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            "base-card",
            Object.assign(
              {},
              _vm.$attrs,
              {
                moduleIcon: _vm.$props.moduleIcon
                  ? _vm.$props.moduleIcon
                  : _vm.cardHeaderIcon
              },
              _vm.$props
            ),
            false
          ),
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }